exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".login-container[data-v-f38c4e38]{max-width:400px;margin:0 auto;padding:20px}.form-group[data-v-f38c4e38]{margin-bottom:15px}.error[data-v-f38c4e38]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f38c4e38","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Login.vue
// module id = 194
// module chunks = 1